<template>
    <v-expand-transition>
        <div>
            <v-menu v-model="localesMenu" :close-on-content-click="false" :disabled="disabled">
                <template v-slot:activator="{props}">
                    <v-btn variant="text" color="black" v-bind="props">
                        <language-label v-if="selectedLocale" :language="selectedLocale" text-button />
                        <v-icon end>mdi-menu-down</v-icon>
                    </v-btn>
                </template>
                <v-list density="compact">
                    <v-list-item v-for="code in useLocales" :key="code" @click="selectLocale(code)">
                        <language-label :language="code" bold />
                    </v-list-item>
                </v-list>
            </v-menu>
        </div>
    </v-expand-transition>
</template>

<script setup lang="ts">
    import LanguageLabel from '~/components/snippets/LanguageLabel.vue'

    const props = defineProps<{
        localeItems?: string[]
        disabled?: boolean
    }>()

    const {$i18n, $conf} = useNuxtApp()
    const localesMenu = ref<boolean>(false)
    const selectedLocale = ref<string>('en')

    const emit = defineEmits<{
        (e: 'change', value: string): void
    }>()

    onMounted(async () => {
        selectedLocale.value = $i18n.locale.value
        emit('change', selectedLocale.value)
    })

    const useLocales = computed(() => {
        return props.localeItems || Object.values($conf.public.locales)
    })

    const selectLocale = (code: string): void => {
        selectedLocale.value = code
        localesMenu.value = false
        emit('change', selectedLocale.value)
    }
</script>
